import { i18n } from '~src/i18n'
export default {
  i18nString: () => string => {
    return i18n.t(string)
  },
  defaultDateFormat: state => state.defaultDateFormat
}
